/**
 * useHeartbeat — pings /api/analytics/heartbeat every 30 s so the
 * backend can count live visitors.  Each tab has a stable session_id
 * persisted in sessionStorage.
 */
import { useEffect } from "react";
import { apiClient } from "./api";

const SID_KEY = "cartal:visitor-sid";
const VID_KEY = "cartal:visitor-vid";

function getOrCreateSid() {
  if (typeof window === "undefined") return null;
  try {
    let sid = window.sessionStorage.getItem(SID_KEY);
    if (!sid) {
      sid = `sid-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      window.sessionStorage.setItem(SID_KEY, sid);
    }
    return sid;
  } catch {
    return null;
  }
}

// iter261 — persistent per-device id (localStorage) so the Geo-Spread
// admin report can count Unique Visitors distinctly from Sessions.
// Not a fingerprint; a random opaque token stored locally.
function getOrCreateVid() {
  if (typeof window === "undefined") return null;
  try {
    let vid = window.localStorage.getItem(VID_KEY);
    if (!vid) {
      vid = `vid-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      window.localStorage.setItem(VID_KEY, vid);
    }
    return vid;
  } catch {
    return null;
  }
}

export function useHeartbeat() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const sid = getOrCreateSid();
    const vid = getOrCreateVid();
    const ping = () => {
      apiClient
        .post("/analytics/heartbeat", { session_id: sid, visitor_id: vid, path: window.location.pathname })
        .catch(() => { /* silent */ });
    };
    ping();
    const id = setInterval(ping, 30_000);
    // Ping on tab focus as well so an inactive tab resumes quickly
    const onFocus = () => ping();
    window.addEventListener("focus", onFocus);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
    };
  }, []);
}

export default useHeartbeat;
